// Angular imports
import { Component, OnInit, Input, Injector, EventEmitter, Output } from '@angular/core';

// Component imports
import { MPSearchBaseComponent } from '../_base/mp-base-search.component';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { SearchService } from '../_services/data-services/search.service';
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { SearchParametersDto } from '../_models/search-parameters-dto';
import { OwnerSearchResultDto } from '../_models/owner-search-result-dto';

@Component({
    selector: 'app-search-properties-current-owners',
    templateUrl: './search-properties-current-owners.component.html',
    styleUrls: ['./search-properties-current-owners.component.scss']
})
export class SearchPropertiesCurrentOwnersComponent extends MPSearchBaseComponent implements OnInit {
    @Input() communityId: number;
    @Input() isQuickSearch: boolean;
    @Output() hideComponentContainer?: EventEmitter<any> = new EventEmitter<any>();
    @Output() saveLastSearchResult: EventEmitter<OwnerSearchResultDto[]> = new EventEmitter<OwnerSearchResultDto[]>();

    hasRecords = false;
    noRecordMessage: string;
    quickSearchText: string;
    isSmallScreen: boolean;
    propertyCurrentOwners: OwnerSearchResultDto[] = [];

    constructor(
        protected readonly injector: Injector,
        private readonly errorService: ServerErrorService,
        private readonly searchService: SearchService,
        private readonly userService: UserService
    ) {
        super(injector);
    }

    ngOnInit() {
        this.updateScreenSize();
        this.screenService.changed.subscribe(() => this.updateScreenSize());
        this.hasRecords = !this.isQuickSearch;
        if (!!this.searchText && !this.isQuickSearch) {
            this.searchCurrentOwners();
        }
    }

    onOpenBalanceClick(data: OwnerSearchResultDto) {
        this.setContextDetails(data);
        this.setPropertyContext(data.communityId, data.accountNumber, 'statement', 'view=open-balance');
    }

    onStatementClick(data: OwnerSearchResultDto) {
        this.setContextDetails(data);
        this.setPropertyContext(data.communityId, data.accountNumber, 'statement', 'view=statement');
    }

    setContextDetails(data: OwnerSearchResultDto): void {
        if (this.isQuickSearch) {
            this.hideComponentContainer.emit(data);
        }
    }

    searchCurrentOwners() {
        if (this.searchText === '') {
            this.propertyCurrentOwners = [];
        } else {
            if (
                this.searchText.length > 2 &&
                (this.propertyCurrentOwners.length === 0 || this.searchText !== this.quickSearchText)
            ) {
                const param: SearchParametersDto = new SearchParametersDto();
                param.clearCache = true;
                param.searchText = this.searchText;
                param.communityId = this.communityId;
                this.propertyCurrentOwners = [];
                this.loadingVisible = true;

                this.searchService.searchCurrentOwners(param).subscribe(
                    (data: OwnerSearchResultDto[]) => {
                        this.changeNavigationState();
                        this.propertyCurrentOwners = data;
                        this.quickSearchText = this.searchText;
                        this.loadingVisible = false;
                        if (this.isQuickSearch) {
                            this.saveLastSearchResult.emit(data);
                        }
                        this.hasRecords = this.propertyCurrentOwners.length > 0;
                        this.noRecordMessage = this.hasRecords
                            ? ''
                            : 'There are no current owners matching the search term.';
                        this.updateGridSearchStatus(data);
                    },
                    (error) => {
                        if (this.isQuickSearch) {
                            this.saveLastSearchResult.emit(null);
                        }
                        this.errorService.displayError(error);
                        this.loadingVisible = false;
                    }
                );
            } else {
                if (this.isQuickSearch) {
                    this.saveLastSearchResult.emit(null);
                }
                this.hasRecords = this.propertyCurrentOwners.length > 0;
                this.noRecordMessage = this.hasRecords ? '' : 'There are no current owners matching the search term.';
                this.updateGridSearchStatus(this.propertyCurrentOwners);
            }
        }
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
    }

    private changeNavigationState(): void {
        if (this.isSmallScreen) {
            this.userService.updateSideNavigatorState(false);
        }
    }
}
